module.exports = __webpack_public_path__ + "career-icon-health.3fEi6ZCA.svg";